import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { baseURL } from "../token";
import axios from "axios";
import logo from "../styles/logo.png";
import { handleUnAuthorized } from "../Components/hooks/handleUnAuthorized";

function HeaderComponent({ userData }) {
  const navigate = useNavigate();

  const amountButtonStyle = {
    borderRadius: "5px",
    border: "1px solid #b7b7b7",
    backgroundColor: "#ffffff",
    height: "34px",
    padding: "0 10px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontWeight: 700,
    fontSize: "13px",
    lineHeight: 1,
    color: "#000000",
  };

  const iconChipStyle = {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f3f4f6",
    fontSize: "12px",
  };

  return (
    <>
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, width: '100%', backgroundColor: '#dc3545', padding: '5px 0', textAlign: 'center', color: 'white', fontSize: '15px', zIndex: 1000 }} >
      Exclusive Offer ! Win Real Cash 😍

    </div>
    <div style={{ paddingTop: '40px' }}>  
      <div
        className="row py-2 align-items-center"
        style={{ backgroundColor: "#fff", boxShadow: "rgba(0, 0, 0, 0.13) 0px 5px 5px"}}
      >
        <div className="col-1 d-flex align-items-center">
          <h4 className="mb-0">
            <i
              onClick={() => navigate("/UserPage")}
              className="bi bi-list"
              style={{ color: "black", cursor: "pointer" }}
            />
          </h4>
        </div>
        <div
          className="col-3"
          style={{ width: "90px", borderRadius: "50%", cursor: "pointer" }}
          onClick={() => navigate("/PlayPage")}
        >
          {/* <span style={{ cursor: 'pointer' }} onClick={() => navigate('/PlayPage')}><img style={{ width: '40px', borderRadius: '50%' }} src={Logo} alt /></span> */}

          <img
            style={{ marginLeft: "10px", width: "80% ", borderRadius: "50%" }}
            src={logo}
            alt
          />
        </div>
        <div className="col-8 d-flex justify-content-end align-items-center">
          {/* <button className="btn btn-light mx-2 align-items-center" onClick={() => navigate('/LanguagesPage')}><i className="bi bi-translate text-primary" /> Language</button> */}

          <a href="/redbullludo.apk" className="text-light align-items-center px-2">
           <img className="w-6" src="/images/download.png" alt="" />
          </a>

          <button
            onClick={() => navigate("/WalletPage")}
            className="btn"
            style={amountButtonStyle}
          >
            <span style={iconChipStyle}>
              <i className="bi bi-wallet-fill text-success" />
            </span>
            <span>{(userData?.Wallet_balance ?? 0).toFixed(2)}</span>
          </button>

          <button
            onClick={() => navigate("/share")}
            className="btn ml-2"
            style={amountButtonStyle}
          >
            <span style={iconChipStyle}>
              <i className="bi bi-gift-fill text-danger" />
            </span>
            <span>{(userData?.referral_earning ?? 0).toFixed(2)}</span>
          </button>
        </div>
      </div>
    </div>
    </>
  );
}

export default HeaderComponent;
